import { render, staticRenderFns } from "./EditProfile.vue?vue&type=template&id=4847c15f&scoped=true"
import script from "./EditProfile.vue?vue&type=script&lang=js"
export * from "./EditProfile.vue?vue&type=script&lang=js"
import style0 from "./EditProfile.vue?vue&type=style&index=0&id=4847c15f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4847c15f",
  null
  
)

export default component.exports